import React from 'react';

import { Button, Dropdown, Menu } from 'antd';
import { ChevronDown } from '@nackle/origami-icons';
import './theme-button.less';

const THEMES = [
    {
        id: null,
        name: 'Shared'
    }, {
        id: '00000000-0000-0000-0000-000000000001',
        name: 'Light Mode'
    }, {
        id: '00000000-0000-0000-0000-000000000002',
        name: 'Dark Mode'
    }
];

export default class ThemeButton extends React.Component {
    state = {
        loading: false,
        themes: [],
        menuVisible: false
    };

    componentDidMount() {
        this.load();
    }

    render() {
        const {
            themeId
        } = this.props;

        const {
            loading,
            themes,
            menuVisible
        } = this.state;

        const theme = themes.find( t => t.id === themeId );

        return (
            <Dropdown
                trigger={ [ 'click' ] }
                visible={ menuVisible }
                onVisibleChange={ this.handleMenuVisibleChange }
                placement="bottomCenter"
                overlay={ (
                    <ThemeMenu
                        themes={ themes }
                        onClick={ this.handleMenuClick }
                    />
                ) }
            >
                <Button
                    type="primary"
                    ghost={ true }
                    disabled={ loading }
                    loading={ loading }
                >
                    <span>
                        { theme ? theme.name : 'Select a Theme...' }
                    </span>
                    <ChevronDown />
                </Button>
            </Dropdown>
        );
    }

    handleMenuVisibleChange = ( visible ) => {
        this.setState( { menuVisible: visible } );
    };
    handleMenuClick = ( themeId ) => {
        const { onChange } = this.props;
        const { themes } = this.state;

        const theme = themes.find( t => t.id === themeId );

        if ( typeof onChange === 'function' ) {
            onChange( theme || { id: null } );
        }

        this.setState( { menuVisible: false } );
    };

    load = async () => {
        this.setState( {
            loading: true,
            loadingErrors: null
        } );

        const themes = THEMES;

        try {
            this.setState( {
                loading: false,
                themes
            } );
        } catch ( { errors } ) {
            this.setState( {
                loading: false,
                loadingErrors: errors
            } );
        }
    };
}

class ThemeMenu extends React.Component {
    render() {
        const { themes } = this.props;

        return (
            <div className="branding-theme-menu-container">
                <Menu
                    onClick={ this.handleMenuItemClick }
                    onVisibleChange={ this.handleVisibleChange }
                >
                    {
                        themes.map( theme => (
                            <Menu.Item key={ theme.id }>
                                <span>{ theme.name }</span>
                            </Menu.Item>
                        ) )
                    }
                </Menu>
            </div>
        );
    }

    handleMenuItemClick = ( e ) => {
        const { onClick } = this.props;

        if ( typeof onClick === 'function' ) {
            onClick( e.key );
        }
    };
}
